module.exports = __webpack_public_path__ + "static/media/daniel-olahh.ff12cd03.jpg";